<form class="parent" [class.backward]="isBackward">
    <input type="radio" name="g1" class="rd rd1" [(ngModel)]="valuePermission"
        [value]="true">
    <input type="radio" name="g1" class="rd rd2" [(ngModel)]="valuePermission" [value]="null">
    <input type="radio" name="g1" class="rd rd3" [(ngModel)]="valuePermission"
        [value]="false">
    <div class="fond">
        <label class="lbl"></label>
    </div>
</form>

